"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./FilterBar.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const FilterBar = /*#__PURE__*/React.forwardRef(({
  InputProps = {},
  filterLabel = 'Filter',
  onChange,
  onFilterClick,
  onSubmit,
  ...otherProps
}, ref) => {
  const [value, setValue] = React.useState('');

  const handleChange = e => {
    setValue(e.currentTarget.value);

    if (typeof onChange === 'function') {
      onChange(e);
    }
  };

  const handleClear = () => {
    setValue('');
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (typeof onSubmit === 'function') {
      onSubmit(e);
    }
  };

  return (0, _pragma.createFelaElement)(_.View, _extends({
    alignItems: "center",
    as: "form",
    gap: "medium",
    onSubmit: handleSubmit
  }, otherProps), (0, _pragma.createFelaElement)(_.View, _extends({
    as: _.Input,
    after: value.length > 0 ? (0, _pragma.createFelaElement)(_.Text, {
      as: "button",
      children: "Clear",
      onClick: handleClear,
      type: "button",
      variant: "meta"
    }) : undefined,
    before: (0, _pragma.createFelaElement)(_.SearchSimpleIcon, {
      color: "ui5"
    }),
    css: css.input,
    flex: true,
    onChange: handleChange,
    placeholder: "Filter in orders",
    ref: ref,
    value: value,
    variant: "secondary"
  }, InputProps)), (0, _pragma.createFelaElement)(_.Button, {
    variant: "secondary",
    size: "small",
    onClick: onFilterClick
  }, filterLabel));
});
FilterBar.displayName = 'FilterBar';
var _default = FilterBar;
exports.default = _default;
//# sourceMappingURL=FilterBar.js.map